module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      component: true, disabled: _vm.loading, 'component--box': true
    }
  }, [_c('div', {
    staticClass: "tab-buttons"
  }, [_c('div', {
    class: {
      'button--square': true, active: (_vm.activeTab === 'details')
    },
    on: {
      "click": function($event) {
        _vm.activeTab = 'details';
        _vm.errorMessage = ''
      }
    }
  }, [_c('span', [_vm._v("Uppgifter")])]), _vm._v(" "), _c('div', {
    class: {
      'button--square': true, active: (_vm.activeTab === 'skiers')
    },
    on: {
      "click": function($event) {
        _vm.activeTab = 'skiers';
        _vm.errorMessage = ''
      }
    }
  }, [_c('span', [_vm._v("Åkare")])]), _vm._v(" "), _c('div', {
    class: {
      'button--square': true, active: (_vm.activeTab === 'passes')
    },
    on: {
      "click": function($event) {
        _vm.activeTab = 'passes';
        _vm.errorMessage = ''
      }
    }
  }, [_c('span', [_vm._v("Liftkort")])])]), _vm._v(" "), _c('div', {
    staticClass: "component__inner"
  }, [_c('Loading', {
    attrs: {
      "show": _vm.loading
    }
  }), _vm._v(" "), (_vm.activeTab === 'details') ? _c('div', {
    staticClass: "tab-content"
  }, [_c('h2', {
    staticClass: "wide"
  }, [_vm._v("Mina uppgifter")]), _vm._v(" "), _c('div', {
    staticClass: "detail-item"
  }, [_c('label', [_vm._v("Förnamn")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.name1),
      expression: "user.name1"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Förnamn"
    },
    domProps: {
      "value": (_vm.user.name1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "name1", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "detail-item"
  }, [_c('label', [_vm._v("Efternamn")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.name2),
      expression: "user.name2"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Efternamn"
    },
    domProps: {
      "value": (_vm.user.name2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "name2", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "detail-item wide"
  }, [_c('label', [_vm._v("Gatuadress")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.addr1),
      expression: "user.addr1"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Gatuadress"
    },
    domProps: {
      "value": (_vm.user.addr1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "addr1", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "detail-item"
  }, [_c('label', [_vm._v("Postnummer")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.addr3),
      expression: "user.addr3"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Postnummer"
    },
    domProps: {
      "value": (_vm.user.addr3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "addr3", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "detail-item"
  }, [_c('label', [_vm._v("Stad")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.addr4),
      expression: "user.addr4"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Stad"
    },
    domProps: {
      "value": (_vm.user.addr4)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "addr4", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "1rem"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "detail-item wide"
  }, [_c('label', [_vm._v("Land")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.addr5),
      expression: "user.addr5"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.user, "addr5", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.filteredCountries), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.title))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "1rem"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "detail-item wide"
  }, [_c('label', [_vm._v("Telefonnummer")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.mobile_phone),
      expression: "user.mobile_phone"
    }],
    attrs: {
      "type": "tel",
      "placeholder": "Telefonnummer"
    },
    domProps: {
      "value": (_vm.user.mobile_phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "mobile_phone", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "detail-item wide"
  }, [_c('label', [_vm._v("E-postadress")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }],
    attrs: {
      "type": "email",
      "placeholder": "E-postadress"
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "email", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.activeTab === 'skiers') ? _c('div', {
    staticClass: "tab-content"
  }, [_c('h2', {
    staticClass: "wide"
  }, [_vm._v("Sparade åkare")]), _vm._v(" "), _c('div', {
    staticClass: "people wide"
  }, [_vm._l((_vm.skiers), function(skier, index) {
    return _c('div', {
      key: index,
      staticClass: "person"
    }, [(skier.deleted_at) ? _c('Note', {
      attrs: {
        "color": "warning",
        "icon": "trash",
        "align": "left"
      }
    }, [_c('p', [_vm._v(_vm._s(skier.first_name || 'Åkaren') + " tas bort när du sparar")])]) : _vm._e(), _vm._v(" "), (!skier.deleted_at) ? _c('div', [_c('div', {
      staticClass: "name-wrapper"
    }, [_c('div', {
      staticClass: "firstname detail-item"
    }, [_c('label', [_vm._v("Förnamn")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (skier.first_name),
        expression: "skier.first_name"
      }],
      attrs: {
        "type": "text",
        "placeholder": "Förnamn"
      },
      domProps: {
        "value": (skier.first_name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(skier, "first_name", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "delete detail-item"
    }, [_c('label', [_vm._v(" ")]), _vm._v(" "), _c('button', {
      staticClass: "button--rounded--outlined--red",
      on: {
        "click": function($event) {
          return _vm.deleteSkier(skier, index)
        }
      }
    }, [_vm._v("Ta bort")])])]), _vm._v(" "), _c('div', {
      staticClass: "multi-details"
    }, [_c('div', {
      staticClass: "detail-item"
    }, [_c('label', [_vm._v("Ålder")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (skier.age),
        expression: "skier.age"
      }],
      attrs: {
        "type": "text",
        "placeholder": "Ålder"
      },
      domProps: {
        "value": (skier.age)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(skier, "age", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "detail-item"
    }, [_c('label', [_vm._v("Längd")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (skier.measurement_height),
        expression: "skier.measurement_height"
      }],
      attrs: {
        "type": "text",
        "placeholder": "Längd"
      },
      domProps: {
        "value": (skier.measurement_height)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(skier, "measurement_height", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "detail-item"
    }, [_c('label', [_vm._v("Vikt")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (skier.measurement_weight),
        expression: "skier.measurement_weight"
      }],
      attrs: {
        "type": "text",
        "placeholder": "Vikt"
      },
      domProps: {
        "value": (skier.measurement_weight)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(skier, "measurement_weight", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "detail-item"
    }, [_c('label', [_vm._v("Skostorlek")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (skier.measurement_shoe_size),
        expression: "skier.measurement_shoe_size"
      }],
      attrs: {
        "type": "text",
        "placeholder": "Skostorlek"
      },
      domProps: {
        "value": (skier.measurement_shoe_size)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(skier, "measurement_shoe_size", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "detail-item"
    }, [_c('label', [_vm._v("Klädstorlek")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (skier.measurement_clothsize),
        expression: "skier.measurement_clothsize"
      }],
      attrs: {
        "type": "text",
        "placeholder": "Klädstorlek"
      },
      domProps: {
        "value": (skier.measurement_clothsize)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(skier, "measurement_clothsize", $event.target.value)
        }
      }
    })])])]) : _vm._e()], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "center wide"
  }, [_c('button', {
    staticClass: "button--rounded button--green",
    on: {
      "click": function($event) {
        return _vm.createNewSkier()
      }
    }
  }, [_vm._v("Lägg till åkare")])])], 2)]) : _vm._e(), _vm._v(" "), (_vm.activeTab === 'passes') ? _c('div', {
    staticClass: "tab-content"
  }, [_c('h2', {
    staticClass: "wide"
  }, [_vm._v("Sparade liftkort")]), _vm._v(" "), _c('div', {
    staticClass: "people wide"
  }, [_vm._l((_vm.skipasses), function(skipass, index) {
    return _c('div', {
      key: index,
      staticClass: "person"
    }, [(skipass.deleted_at) ? _c('Note', {
      attrs: {
        "color": "warning",
        "icon": "trash",
        "align": "left"
      }
    }, [_c('p', [_vm._v(_vm._s(skipass.name || 'Liftkortet') + " tas bort när du sparar")])]) : _vm._e(), _vm._v(" "), (!skipass.deleted_at) ? _c('div', [_c('div', {
      staticClass: "name-wrapper"
    }, [_c('div', {
      staticClass: "firstname detail-item"
    }, [_c('label', [_vm._v("Namn på liftkort")]), _vm._v(" "), _c('p', [_vm._v("(om du vill komma ihåg vems det är)")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (skipass.name),
        expression: "skipass.name"
      }],
      attrs: {
        "type": "text",
        "placeholder": "Namn på liftkort"
      },
      domProps: {
        "value": (skipass.name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(skipass, "name", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "delete detail-item"
    }, [_c('label', [_vm._v(" ")]), _vm._v(" "), _c('button', {
      staticClass: "button--rounded--outlined--red",
      on: {
        "click": function($event) {
          return _vm.deleteSkipass(skipass, index)
        }
      }
    }, [_vm._v("Ta bort")])])]), _vm._v(" "), _c('div', {
      staticClass: "detail-item wide"
    }, [_c('label', [_vm._v("Nummer")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (skipass.number),
        expression: "skipass.number"
      }],
      attrs: {
        "type": "text",
        "placeholder": "Nummer"
      },
      domProps: {
        "value": (skipass.number)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(skipass, "number", $event.target.value)
        }
      }
    })])]) : _vm._e()], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "center wide"
  }, [_c('button', {
    staticClass: "button--rounded",
    on: {
      "click": function($event) {
        return _vm.createNewSkipass()
      }
    }
  }, [_vm._v("Lägg till liftkort")])])], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "1.5rem"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "center wide"
  }, [(_vm.errorMessage) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errorMessage))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "center wide"
  }, [_c('button', {
    staticClass: "button--rounded",
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("Spara")])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d7376494"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pages/MyPages/MyPageDetails.vue
// module id = 1029
// module chunks = 0